import clsx from "clsx";
import DashboardHeader from "../dashboardHeader";
import ChecklistCompactPageHeader from "../quality/checklists/ChecklistCompactPageHeader";
import { pickHseCompactActions } from "./HsePageChromeUtils";

export { pickHseCompactActions, useHseBusyAction } from "./HsePageChromeUtils";

/**
 * Shared HSE/KS page chrome: desktop DashboardHeader + the same compact
 * mobile header used on report checklists (ChecklistCompactPageHeader).
 */
export function HsePageChrome({
  title,
  subtitle,
  backTo,
  backUrl,
  statusLabel,
  progressLabel,
  compactActions,
  chromeClassName,
  actions,
  mainButton,
  children,
  ...headerProps
}) {
  const resolvedBack = backTo || backUrl || null;
  const mobileActions =
    compactActions ||
    pickHseCompactActions({ actions, mainButton });

  return (
    <>
      <div
        className="fixed z-40 border-b border-[#e5e8ec] bg-white/95 shadow-[0_4px_14px_rgba(20,23,28,0.08)] backdrop-blur-sm supports-[backdrop-filter]:bg-white/92 xl:hidden"
        style={{
          top: "var(--dashboard-topbar-height, 4rem)",
          left: "var(--dashboard-sidebar-width, 0px)",
          right: 0,
        }}
      >
        <ChecklistCompactPageHeader
          title={title}
          subtitle={subtitle}
          backTo={resolvedBack}
          progressLabel={progressLabel}
          statusLabel={statusLabel}
          actions={mobileActions}
          className="border-b-0"
        />
      </div>
      <div className="h-11 flex-shrink-0 xl:hidden" aria-hidden />
      <DashboardHeader
        {...headerProps}
        title={title}
        subtitle={subtitle}
        backUrl={resolvedBack || undefined}
        actions={actions}
        mainButton={mainButton && mainButton.hidden === true ? undefined : mainButton}
        chromeClassName={clsx("hidden xl:block", chromeClassName)}
      >
        {children}
      </DashboardHeader>
    </>
  );
}

export default HsePageChrome;
